import { Controller } from "@hotwired/stimulus";

export class HomeController extends Controller {
  connect() {
    console.log("stimulus connected!");
  }
}
